import { useState, useEffect, useRef } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import ThemeSelector from '../../components/ThemeSelector';
import styles from './LandingLayout.module.css';

const NAV_LINKS = [
  { label: 'Home',     to: '/' },
  { label: 'About',    to: '/about' },
  { label: 'Derasars', to: '/derasars' },
  { label: 'Features', to: '/features' },
  { label: 'Privacy',  to: '/privacy' },
  { label: 'Terms',    to: '/terms' },
  { label: 'Pricing',  to: '/pricing' },
  { label: 'Refund',   to: '/refund' },
  { label: 'Request Demo', to: '/request-demo' },
  { label: 'Contact',  to: '/contact' },
  { label: 'Support',  to: '/support' },
];

const LandingLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const mobileRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (mobileRef.current && !mobileRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };
    if (mobileOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [mobileOpen]);

  return (
    <div className={styles.page}>
      <nav className={styles.nav} ref={mobileRef}>
        {/* Brand */}
        <Link to="/" className={styles.navBrand}>
          <img src="/icon.png" alt="Jainam Seva Setu" className={styles.brandIcon} />
          <span className={styles.navBlue}>Jainam</span>
          <span className={styles.navGold}>Seva</span>
          <span className={styles.navBlue}>Setu</span>
        </Link>

        {/* Centre links */}
        <ul className={`${styles.navLinks} ${mobileOpen ? styles.navLinksOpen : ''}`}>
          {NAV_LINKS.map(l => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                className={({ isActive }) =>
                  `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                }
                onClick={() => setMobileOpen(false)}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
          <li className={styles.mobileAuthRow}>
            <Link to="/login/admin" className={styles.btnAdmin} onClick={() => setMobileOpen(false)}>
              <span className={styles.labelShort}>Admin</span>
            </Link>
            <Link to="/login" className={styles.btnMember} onClick={() => setMobileOpen(false)}>
              <span className={styles.labelShort}>Member</span>
            </Link>
          </li>
        </ul>

        {/* Right — two login buttons + theme */}
        <div className={styles.navRight}>
          <ThemeSelector />
          <Link to="/login/admin" className={styles.btnAdmin}>
            <span className={styles.labelShort}>Admin</span>
          </Link>
          <Link to="/login" className={styles.btnMember}>
            <span className={styles.labelShort}>Member</span>
          </Link>
          <button
            className={styles.hamburger}
            onClick={() => setMobileOpen(o => !o)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <FiX size={20} /> : <FiMenu size={20} />}
          </button>
        </div>
      </nav>

      <main>
        <Outlet />
      </main>

      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <img src="/icon.png" alt="Jainam Seva Setu" className={styles.footerIcon} />
            <span className={styles.brandBlue}>Jainam</span>
            <span className={styles.brandGold}>Seva</span>
            <span className={styles.brandBlue}>Setu</span>
          </div>
          <div className={styles.footerLinks}>
            {NAV_LINKS.map(l => (
              <Link key={l.to} to={l.to} className={styles.footerLink}>{l.label}</Link>
            ))}
          </div>
          <p className={styles.footerCopy}>
            &copy; {new Date().getFullYear()} Jainam Seva Setu &mdash; All rights reserved
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingLayout;
